import { render, staticRenderFns } from "./AddEditSpecimensType.vue?vue&type=template&id=102570f3&scoped=true"
import script from "./AddEditSpecimensType.vue?vue&type=script&lang=js"
export * from "./AddEditSpecimensType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102570f3",
  null
  
)

export default component.exports